import { render } from "./BlogPostPage.vue?vue&type=template&id=0200ad16"
import script from "./BlogPostPage.vue?vue&type=script&lang=js"
export * from "./BlogPostPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__